import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { MODAL_WIDTH } from '../constants/ModalConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const ExitEditorWarningModal = ({
  description,
  onConfirm,
  onReject
}) => /*#__PURE__*/_jsx(UIConfirmModal, {
  message: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "knowledgeContentUI.shared.exitWarning.message"
  }),
  description: description,
  confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "knowledgeContentUI.shared.exitWarning.confirmLabel"
  }),
  onConfirm: onConfirm,
  rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "knowledgeContentUI.shared.exitWarning.rejectLabel"
  }),
  onReject: onReject,
  width: MODAL_WIDTH
});
ExitEditorWarningModal.propTypes = {
  description: PropTypes.node.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired
};
export default ExitEditorWarningModal;